export const formatDate = (date?: string) => {
  const newDate = date ? new Date(date) : new Date();
  const day = newDate.getUTCDate().toString().padStart(2, '0');
  const month = (newDate.getUTCMonth() + 1).toString().padStart(2, '0');
  const year = newDate.getUTCFullYear();

  return `${day}/${month}/${year}`;
};

export const formatLongDate = (date: string) =>
  new Date(date).toLocaleDateString('pt-BR', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    timeZone: 'America/Sao_Paulo',
  });

export const formatShortDate = (date: string) =>
  new Date(date).toLocaleDateString('pt-BR', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    timeZone: 'America/Sao_Paulo',
  });

export const formatTime = (date?: string) => {
  const newDate = date ? new Date(date) : new Date();

  const hour = newDate.getHours().toString().padStart(2, '0');
  const minutes = newDate.getMinutes().toString().padStart(2, '0');

  return `${hour}:${minutes}`;
};

export const extractDuration = (duration: string) => {
  const splited = duration.split(':');
  const hours = parseInt(splited[0]);
  const minutes = parseInt(splited[1]);
  const seconds = parseInt(splited[2]);

  if (hours > 0) {
    return `${hours}${
      minutes > 0 ? ':' + minutes.toString().padStart(2, '0') : ''
    } hora${hours > 1 || minutes > 0 ? 's' : ''}`;
  }

  if (minutes > 0) {
    return `${minutes}${
      seconds > 0 ? ':' + seconds.toString().padStart(2, '0') : ''
    } minuto${minutes > 1 || seconds > 0 ? 's' : ''}`;
  }
  return `${seconds} segundo${seconds > 1 ? 's' : ''}`;
};

export const lastYearMonths = () => {
  const date = Date.now();
  const months = [];
  for (let i = 0; i < 12; i += 1) {
    const newDate = new Date(date);
    newDate.setMonth(newDate.getMonth() - i);
    const month = newDate.toLocaleString('default', { month: 'short' });
    months.unshift(month);
  }

  return months;
};
